export default "__VITE_ASSET__3bee88d5__"